import { FC, useCallback } from 'react';
import { AudioCallStatuses } from 'constants/voip';

import MeetingAction from '../MeetingAction';

interface IProps {
  status: AudioCallStatuses | undefined;
  isEnabled: boolean;
  onChange(value: boolean): void;
}

const CameraButton: FC<IProps> = ({ status, isEnabled }) => {
  const onToggleVideo = useCallback(async () => {
    // TODO: removed to implement with twilio
  }, []);

  return (
    <MeetingAction
      isSelected={isEnabled}
      isDisabled={status !== AudioCallStatuses.connected}
      icon={isEnabled ? 'videoDark' : 'video'}
      onClick={onToggleVideo}
    />
  );
};

export default CameraButton;
